import IconDescription from "@/components/IconDescription";

export function getEstimationDurationIcon(title: string, subtitle: string) {
  return (
    <IconDescription iconType="timelapse" title={title} subtitle={subtitle} />
  );
}
